/**
 * Transforms group of exchangeables.
 * Currently only trips are supported.
 */
export function transformExchangeableGroups(bookingParts: ApiBookingPart[], response: ApiSchema['BookingResponse']): ExchangeableGroup[] {
    return [
        ...transformExchangeableGroupsTrip(bookingParts, response),
    ];
}
